import {
  USERROLES, EMPLOYEE_ROLE, ROLES_BY_ID,
  GROUPTYPES_CLASS, GROUPTYPES_GENERAL, GROUPTYPES_SCHOOL, GROUPTYPES_FOUNDATION,
  GROUPLEVELS_SCHOOL, GROUPLEVELS_FOUNDATION,
} from 'containers/User/constants.js';
import messages from './messages.js';

// export const MEMBERTYPE_APPLICATION = 4;
// export const MEMBERTYPE_EMPL_STAFF = 5;
export const MEMBERTYPE_STAFF = 6;
export const MEMBERTYPE_GROUP = 7;
export const MEMBERTYPE_ADMINGROUP = 8;

export const MEMBER_USERS_BY_ID = {
  ...ROLES_BY_ID,
  [MEMBERTYPE_STAFF]: 'employee',
};

export const GROUP_MEMBER_TYPES = {
  [GROUPLEVELS_SCHOOL]: [
    {
      id: 'school',
      key: GROUPTYPES_SCHOOL,
      intro: messages.schoolIntro,
      memberTypes: USERROLES,
    },
    {
      id: 'classes',
      key: GROUPTYPES_CLASS,
      intro: messages.classIntro,
      addLabel: messages.addClass,
      memberTypes: [...USERROLES, { id: MEMBERTYPE_ADMINGROUP, name: 'adminGroups' }],
    },
    {
      id: 'general',
      key: GROUPTYPES_GENERAL,
      intro: messages.generalIntro,
      addLabel: messages.addGroup,
      memberTypes: [...USERROLES, { id: MEMBERTYPE_GROUP, name: 'groups' }],
    },
    { id: 'archive', intro: messages.archiveIntro },
  ],
  [GROUPLEVELS_FOUNDATION]: [
    {
      id: 'school',
      noTab: true,
      key: GROUPTYPES_SCHOOL,
      intro: messages.schoolIntro,
      memberTypes: [...USERROLES, { id: MEMBERTYPE_STAFF, name: 'staff' }],
    },
    {
      id: 'foundation',
      key: GROUPTYPES_FOUNDATION,
      intro: messages.foundationIntro,
      memberTypes: [{ id: EMPLOYEE_ROLE, name: 'employee' }, { id: MEMBERTYPE_STAFF, name: 'staff' }],
    },
    {
      id: 'general',
      key: GROUPTYPES_GENERAL,
      intro: messages.generalFoundationIntro,
      addLabel: messages.addGroup,
      memberTypes: [...USERROLES, { id: MEMBERTYPE_STAFF, name: 'staff' }, { id: MEMBERTYPE_GROUP, name: 'groups' }],
    },
    { id: 'archive', intro: messages.archiveIntro },
  ],
};
